import {
  DeliveredPatientStatementsDTO,
} from 'dtos/deliveredPatientStatementsDTO';
import {
  PatientStatementAppointmentSnapshotDTO,
} from 'dtos/patientStatementAppointmentSnapshotDTO';
import {
  InsuranceBalanceExplanationDTO,
} from 'dtos/insuranceBalanceExplanationDTO';
import {
  getApiBillingExplainInsuranceBalanceEncounterId,
  getApiBillingGetDeliveredPatientStatementsPatientId,
  getApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogId,
  getApiPatientGetPatientLedgerPatientId,
} from 'endpoints';
import {
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import {
  LedgerData,
} from 'pages/Dashboard/pages/Ledger/types';
import {
  normalizeLedgerData,
} from 'pages/Dashboard/pages/Ledger/helper';

export function useGetLedgerData(patientId: number): UseQueryResult<LedgerData, Error> {
  return useQuery<LedgerData, Error>({
    queryKey: ['ledger', patientId],
    queryFn: async ({ signal }) => {
      const response = await getApiPatientGetPatientLedgerPatientId(patientId, { signal });
      return normalizeLedgerData(response);
    },
  });
}

export function useGetDeliveredPatientStatements(patientId: number): UseQueryResult<
  DeliveredPatientStatementsDTO, Error> {
  return useQuery<DeliveredPatientStatementsDTO, Error>({
    queryKey: ['delivered-patient-statements', patientId],
    queryFn: () => getApiBillingGetDeliveredPatientStatementsPatientId(patientId),
  });
}

export function useGetPatientStatementEncounterSnapshots(
  id: number,
): UseQueryResult<PatientStatementAppointmentSnapshotDTO[], Error> {
  return useQuery<PatientStatementAppointmentSnapshotDTO[], Error>({
    queryKey: ['patient-statement-encounter-snapshots', id],
    queryFn: () =>
      getApiBillingGetPatientStatementEncounterSnapshotsPatientStatementDeliveryLogId(id),
  });
}

export function useGetInsuranceBalanceExplanation(
  encounterId: number,
  enabled = false,
): UseQueryResult<InsuranceBalanceExplanationDTO, Error> {
  return useQuery<InsuranceBalanceExplanationDTO, Error>({
    queryKey: ['insurance-balance-explanation', encounterId],
    queryFn: ({ signal }) => getApiBillingExplainInsuranceBalanceEncounterId(encounterId, { signal }),
    enabled: encounterId > 0 && enabled,
  });
}
